<template>
  <b-card>
    <b-card-body>
      <b-row>
        <b-col
            cols="12"
            sm="12"
        >
          <b-row
              class="mb-1"
          >
            <b-col
                cols="12"
                class="d-flex align-items-center"
            >
              <h2>Upwork</h2>
            </b-col>
          </b-row>
        </b-col>
        <b-col
            cols="12"
            sm="12"
        >
          <b-row
              class="mb-1"
          >
            <b-col
                cols="2"
                class="d-flex align-items-center"
            >
              <h4>Get Upwork tracking</h4>
            </b-col>
            <b-col
                cols="3"
                class="d-flex align-items-center"
            >
              <VueCtkDateTimePicker
                v-model="dateModelUpwork"
                format="YYYY-MM-DD"
                range
                locale="en"
                auto-close
                :first-day-of-week=1
                :dark="this.$store.state.appConfig.layout.skin === 'dark'"
                color="#F05A28"
                :custom-shortcuts="myRanges"
                :shortcut="'mtd'"
              />
            </b-col>
            <b-col
                cols="3"
                class="d-flex align-items-center"
            >
                <b-button
                    variant="primary"
                    class="mr-2"
                    :disabled="loadingUpwork"
                    style="width: 20rem"
                    @click="getTracking('Upwork')"
                >
                  Get Data
                </b-button>
                <b-spinner
                    v-if="loadingUpwork"
                    variant="primary"
                />
                <span
                    v-if="statusUpwork.status && !loadingUpwork"
                    :class="statusUpwork.status ? `text-success font-weight-bolder` : `text-danger font-weight-bolder`"
                >
                  {{ statusUpwork.title }}
                </span>
            </b-col>
          </b-row>
        </b-col>
        <b-col
            cols="12"
            sm="12"
        >
          <b-row
              class="mb-1"
          >
            <b-col
                cols="12"
                class="d-flex align-items-center"
            >
              <h2>Hubstaff</h2>
            </b-col>
          </b-row>
        </b-col>
        <b-col
            cols="12"
            sm="12"
        >
          <b-row
              class="mb-1"
          >
            <b-col
                cols="2"
                class="d-flex align-items-center"
            >
              <h4>Get Hubstaff tracking</h4>
            </b-col>
            <b-col
                cols="3"
                class="d-flex align-items-center"
            >
              <VueCtkDateTimePicker
                  v-model="dateModelHubstaff"
                  format="YYYY-MM-DD"
                  range
                  locale="en"
                  auto-close
                  :first-day-of-week=1
                  :dark="this.$store.state.appConfig.layout.skin === 'dark'"
                  color="#F05A28"
                  :custom-shortcuts="myRanges"
                  :shortcut="'mtd'"
              />
            </b-col>
            <b-col
                cols="3"
                class="d-flex align-items-center"
            >
              <b-button
                  variant="primary"
                  class="mr-2"
                  :disabled="loadingHubstaff"
                  style="width: 20rem"
                  @click="getTracking('Hubstaff')"
              >
                Get Data
              </b-button>
              <b-spinner
                  v-if="loadingHubstaff"
                  variant="primary"
              />
              <span
                  v-if="statusHubstaff.status && !loadingHubstaff"
                  :class="statusHubstaff.status ? `text-success font-weight-bolder` : `text-danger font-weight-bolder`"
              >
                  {{ statusHubstaff.title }}
                </span>
            </b-col>
          </b-row>
        </b-col>
        <b-col
            cols="12"
            sm="12"
        >
          <b-row
              class="mb-1"
          >
            <b-col
                cols="12"
                class="d-flex align-items-center"
            >
              <h2>ClickUp</h2>
            </b-col>
          </b-row>
        </b-col>
        <b-col
            cols="12"
            sm="12"
        >
          <b-row
              class="mb-1"
          >
            <b-col
                cols="2"
                class="d-flex align-items-center"
            >
              <h4>Get ClickUp tracking</h4>
            </b-col>
            <b-col
                cols="3"
                class="d-flex align-items-center"
            >
              <VueCtkDateTimePicker
                  v-model="dateModelClickUp"
                  format="YYYY-MM-DD"
                  range
                  locale="en"
                  auto-close
                  :first-day-of-week=1
                  :dark="this.$store.state.appConfig.layout.skin === 'dark'"
                  color="#F05A28"
                  :custom-shortcuts="myRanges"
                  :shortcut="'mtd'"
              />
            </b-col>
            <b-col
                cols="3"
                class="d-flex align-items-center"
            >
              <b-button
                  variant="primary"
                  class="mr-2"
                  :disabled="loadingClickup"
                  style="width: 20rem"
                  @click="getTracking('Clickup')"
              >
                Get Data
              </b-button>
              <b-spinner
                  v-if="loadingClickup"
                  variant="primary"
              />
              <span
                  v-if="statusClickUp.status && !loadingClickup"
                  :class="statusClickUp.status ? `text-success font-weight-bolder` : `text-danger font-weight-bolder`"
              >
                  {{ statusClickUp.title }}
                </span>
            </b-col>
          </b-row>
          <b-row
              class="mb-1 d-flex align-items-center"
          >
            <b-col
                cols="2"
                class="d-flex align-items-center"
            >
              <h4>Sync Epics and Theirs Tasks</h4>
            </b-col>
            <b-col
                cols="3"
                class="d-flex align-items-center"
            >
              <b-form-select
                  v-model="selectedProject"
                  :options="projects"
                  text-field="name"
                  value-field="id"
                  class="w-100"
              >
                <template #first>
                  <b-form-select-option :value="null" disabled>
                    -- Select an Project --
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
            <b-col
                cols="3"
                class="d-flex align-items-center"
            >
              <b-button
                  variant="primary"
                  class="mr-2"
                  :disabled="projectSyncLoading"
                  style="width: 20rem"
                  @click="syncEpics"
              >
                Sync
              </b-button>
              <b-spinner
                  v-if="projectSyncLoading"
                  variant="primary"
              />
              <span
                  v-if="epicsSyncResult"
                  :class="epicsSyncResult.status ? `text-success font-weight-bolder` : `text-danger font-weight-bolder`"
              >
                  {{ epicsSyncResult.title }}
                </span>
            </b-col>
          </b-row>
          <b-row
              v-for="button in buttonsMTD"
              :key="button.title"
              class="mb-1"
          >
            <b-col
                cols="2"
                class="d-flex align-items-center"
            >
              <h4>{{ button.title }}</h4>
            </b-col>
            <b-col
                cols="6"
                class="d-flex align-items-center"
            >
              <b-button
                  :variant="button.variant"
                  class="mr-2"
                  :disabled="button.loading"
                  style="width: 20rem"
                  @click="get(button)"
              >
                Get data
              </b-button>
              <b-spinner
                  v-if="button.loading"
                  variant="primary"
              />
              <span
                  v-if="button.status && !button.loading"
                  :class="button.status.status ? `text-success font-weight-bolder` : `text-danger font-weight-bolder`"
              >
                {{ button.status.title }}
              </span>
            </b-col>
          </b-row>
          <b-row
              class="mb-1"
          >
            <b-col
                cols="3"
                class="d-flex align-items-center"
            >
              <VueCtkDateTimePicker
                  v-model="dateModelExport"
                  format="YYYY-MM-DD"
                  range
                  locale="en"
                  auto-close
                  :first-day-of-week=1
                  :dark="this.$store.state.appConfig.layout.skin === 'dark'"
                  color="#F05A28"
                  :custom-shortcuts="myRanges"
                  :shortcut="'mtd'"
              />
            </b-col>
            <b-col
                cols="3"
                class="d-flex align-items-center"
            >
              <b-button
                  variant="primary"
                  class="mr-2"
                  :disabled="loadingExport"
                  style="width: 20rem"
                  @click="getTransaction()"
              >
                Export transaction
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
        >
          <span class="font-weight-bold font-large-1">Import Transactions</span>
        </b-col>
        <b-col
          cols="12"
          sm="3"
          md="3"
        >
          <b-form-file
            v-model="file"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            :accept="acceptedTypes"
          />
        </b-col>
        <b-col
          cols="12"
          sm="3"
          md="3"
        >
          <b-spinner
            v-if="loading"
            variant="primary"
          />
          <b-button
            v-else
            variant="primary"
            @click="importTransactions"
          >
            Import
          </b-button>
        </b-col>
        <b-col
          cols="12"
        >
          <b-link
            :href="sampleDownload"
          >
            Sample File
          </b-link>
        </b-col>
        <b-col
            cols="12"
            class="mt-1"
        >
          <span class="font-weight-bold font-large-1">
            Log Import
          </span>
          <feather-icon
              size="24"
              icon="RefreshCcwIcon"
              class="mr-50 cursor-pointer"
              style="margin-bottom: 10px"
              v-on:click="getLogImports"
          />
        </b-col>

        <b-overlay
            :show="loading2"
            spinner-type="grow"
            spinner-variant="primary"
            :variant="`transparent`"
            :opacity="1"
            :blur="`2px`"
            rounded="lg"
        >
          <p v-if="logImports.length === 0">
            Nothing to Show
          </p>
        <b-table
            v-else
            hover
            responsive
            :items="logImports"
            :fields="fields"
        >

          <template
              #cell(created_at)="data"
          >

              {{ data.item.created_at | moment("MM-DD-YYYY HH-mm-ss") }}


          </template>
          <template
              #cell(status)="data"
          >
            <b-badge
                :variant="data.item.status === 'Finished' ? `light-success` : data.item.status === 'Failed'
                  ? `light-danger` : `light-primal`"
            >
              {{ data.item.status }}
            </b-badge>

          </template>
        </b-table>
        </b-overlay>
        <b-col
          cols="12"
          class="mt-1"
        >
          <span class="font-weight-bold font-large-1">
            Wrong Naming
          </span>
        </b-col>
        <b-col
          v-for="wname in wrongNames"
          :key="wname.id"
          cols="12"
        >
          <span class="font-weight-bolder">
            {{ wname.name }}
          </span> parsed from
          <span class="font-weight-bolder">
            {{ wname.source }}
          </span>
          doesn’t have a match
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BButton,
  BSpinner,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BFormFile,
  BLink,
  BTable,
  BBadge,
  BOverlay,
  BFormSelectOption,
  BFormSelect
} from 'bootstrap-vue'
import axiosIns from '@/libs/axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { analysError } from '@/_helpers/analys_error'

export default {
  components: {
    BFormSelect, BFormSelectOption,
    BButton,
    BSpinner,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BFormFile,
    BOverlay,
    BLink,
    BTable,
    BBadge
  },
  data() {
    return {
      file: [],
      acceptedTypes: '.csv',
      logImports: [],
      loadingUpwork: false,
      loadingClickup: false,
      loadingExport: false,
      statusUpwork: {},
      statusClickUp: {},
      loadingHubstaff: false,
      statusHubstaff: {},
      dateModelUpwork: {},
      dateModelExport: {},
      dateModelClickUp: {},
      dateModelHubstaff: {},
      myRanges: [
        { key: 'thisWeek', label: 'This week', value: 'isoWeek' },
        { key: 'lastWeek', label: 'Last week', value: '-isoWeek' },
        { key: 'thisMonth', label: 'This month', value: 'month' },
        { key: 'lastMonth', label: 'Last month', value: '-month' },
        {
          key: 'ytd',
          label: 'YTD',
          value: () => ({
            start: this.$moment().startOf('year'),
            end: this.$moment(),
          }),
        },
        {
          key: 'mtd',
          label: 'MTD',
          value: () => ({
            start: this.$moment().startOf('month'),
            end: this.$moment(),
          }),
        },
      ],
      fields: [
        {
          key: 'created_at', label: 'Created Date', sortable: false, tdClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'status', label: 'Status', sortable: false, tdClass: 'text-center', thClass: 'text-center',
        },
        {
          key: 'message', label: 'message', sortable: false, tdClass: 'text-left', thClass: 'text-center',
        },
      ],
      buttonsMTD: [
        {
          title: 'Get ClickUp spaces',
          url: 'clickUp/spaces',
          variant: 'primary',
          loading: false,
          status: {},
        },
        {
          title: 'Get ClickUp talents',
          url: 'clickUp/comrades',
          variant: 'primary',
          loading: false,
          status: {},
        },
      ],
      buttonsYTD: [
        {
          title: 'Get Hubstaff tracking data YTD',
          url: 'tracking/get',
          urlParams: '?YTD&source=Hubstaff',
          variant: 'primary',
          loading: false,
          status: {},
        },
        {
          title: 'Get Upwork tracking data YTD',
          url: 'tracking/get',
          urlParams: '?YTD&source=Upwork',
          variant: 'primary',
          loading: false,
          status: {},
        },
        {
          title: 'Get ClickUp tracking data YTD',
          url: 'tracking/get',
          urlParams: '?YTD&source=Clickup',
          variant: 'primary',
          loading: false,
          status: {},
        },
      ],
      wrongNames: [],
      loading: false,
      loading2: false,
      sampleDownload: `${process.env.VUE_APP_API_URL}/download/transactions/import-example`,
      selectedProject: null,
      projects: [],
      projectSyncLoading: false,
      epicsSyncResult: null
    }
  },
  beforeMount() {
    this.getWrongNames()
    this.getLogImports()
    this.getProjects()
  },
  methods: {
    importTransactions() {
      if (!this.file) {
        return
      }
      this.loading = true
      const formData = new FormData()
      formData.append('file', this.file)
      axiosIns.post('/transaction/import', formData).then(response => {
        this.loading = false
        this.$swal({
          title: response.data.message,
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
        this.getLogImports()
      }).catch(error => {
        this.loading = false
        const errorRes = analysError(error.response)
        const self = this
        errorRes.forEach(value => {
          self.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: value,
              icon: 'CoffeeIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    getTracking(source) {
      let url = 'tracking/get'
      if (source === 'Clickup') {
        if (
            this.dateModelClickUp === null
            || this.dateModelClickUp.start === null
            || this.dateModelClickUp.end === null
        ) return
        url +=`?from=${this.dateModelClickUp.start}&to=${this.dateModelClickUp.end}`;
      } else if (source === 'Hubstaff') {
        if (
            this.dateModelHubstaff === null
            || this.dateModelHubstaff.start === null
            || this.dateModelHubstaff.end === null
        ) return
        url +=`?from=${this.dateModelHubstaff.start}&to=${this.dateModelHubstaff.end}`;
      } else {
        if (
            this.dateModelUpwork === null
            || this.dateModelUpwork.start === null
            || this.dateModelUpwork.end === null
        ) return
        url +=`?from=${this.dateModelUpwork.start}&to=${this.dateModelUpwork.end}`;
      }
      this.setStatus(source, true);
      url +=`&source=${source}`;
      axiosIns.get(`/settings/${url}`).then(response => {
        this.setStatus(source, false)
        if (source === 'Clickup') {
          this.statusClickUp = response.data.data
        } else if (source === 'Hubstaff') {

          this.statusHubstaff = response.data.data
        } else {
          this.statusUpwork = response.data.data
        }
        console.log( this.statusHubstaff)
      }).catch(error => {
        this.setStatus(source, false)
        const errorRes = analysError(error.response)
        const self = this
        errorRes.forEach(value => {
          self.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: value,
              icon: 'CoffeeIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    getTransaction() {
      let url = 'transactions/get'
      if (
          this.dateModelExport === null
          || this.dateModelExport.start === null
          || this.dateModelExport.end === null
      ) return
      url +=`?from=${this.dateModelExport.start}&to=${this.dateModelExport.end}`;
      axiosIns.get(`/settings/${url}`).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.csv');
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        this.setStatus(source, false)
        const errorRes = analysError(error.response)
        const self = this
        errorRes.forEach(value => {
          self.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: value,
              icon: 'CoffeeIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    setStatus(source, status) {
      if (source === 'Clickup') {
        this.loadingClickup = status
      } else if (source === 'Hubstaff') {
        this.loadingHubstaff = status
      } else {
        this.loadingUpwork = status
      }
    },
    get(button) {
      button.loading = true
      let url = button.url
      if (button?.urlParams) {
        url = button.url + button.urlParams
      }
      axiosIns.get(`/settings/${url}`).then(response => {
        button.loading = false
        button.status = response.data.data
      }).catch(error => {
        button.loading = false
        const errorRes = analysError(error.response)
        const self = this
        errorRes.forEach(value => {
          self.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: value,
              icon: 'CoffeeIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    getWrongNames() {
      axiosIns.get('settings/wrong-names').then(response => {
        this.wrongNames = response.data.data
      }).catch(error => {
        this.loading = false
        const errorRes = analysError(error.response)
        const self = this
        errorRes.forEach(value => {
          self.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: value,
              icon: 'CoffeeIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    syncEpics() {
      if (!this.selectedProject) return

      this.projectSyncLoading = true
      axiosIns.post(`settings/project-tasks-epics-sync/${this.selectedProject}`).then(response => {
        this.epicsSyncResult = response.data.data
      }).finally(() => {
        this.projectSyncLoading = false
      })
    },
    getProjects() {
      this.loading2 = true
      axiosIns.get('settings/projects').then(response => {
        this.projects = response.data.data
      }).finally(() => {
        this.loading2 = false
      })
    },
    getLogImports() {
      this.loading2 = true
      axiosIns.get('log_import').then(response => {
        this.logImports = response.data.data
        this.loading2 = false
      }).catch(error => {
        this.loading2 = false
        const errorRes = analysError(error.response)
        const self = this
        errorRes.forEach(value => {
          self.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: value,
              icon: 'CoffeeIcon',
              variant: 'error',
            },
          })
        })
      })
    },
  },
}
</script>

<style scoped>

</style>
